module.exports = __webpack_public_path__ + "static/media/Projets-Immobilier-Vaud.11e04a64.jpg";